// extracted by mini-css-extract-plugin
export default {"faqsDivDark":"FAQs_faqsDivDark__VAXv8","faqsSectionLight":"FAQs_faqsSectionLight__u-M-G","faqsSectionDark":"FAQs_faqsSectionDark__oXaKa"};